import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Currency } from "@front/m19-api-client";
import { AuthService, CurrencyService, UserSelectionService } from "@front/m19-services";
import {
  IBadgeComponent,
  IIconComponent,
  IPopoverComponent,
  IPopoverContentDirective,
  IPopoverTriggerDirective,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-budget-currency-badge",
  imports: [
    IBadgeComponent,
    IPopoverComponent,
    IPopoverTriggerDirective,
    IPopoverContentDirective,
    CommonModule,
    IIconComponent,
    TranslocoDirective,
  ],
  templateUrl: "./budget-currency-badge.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BudgetCurrencyBadgeComponent {
  private readonly userSelectionService = inject(UserSelectionService);
  private readonly currencyService = inject(CurrencyService);
  private readonly authService = inject(AuthService);

  readonly amount = input.required<number | null | undefined>();
  readonly budgetCurrency = input.required<Currency>();

  readonly selectedCurrency = toSignal(this.userSelectionService.selectedCurrency$, {
    requireSync: true,
  });
  readonly locale = toSignal(this.authService.userLocale$, { requireSync: true });

  protected readonly isMismatch = computed(() => this.budgetCurrency() !== this.selectedCurrency());

  protected readonly rate = computed(() => {
    const rates = this.currencyService.getCurrencyRates();
    return rates[this.budgetCurrency()] / rates[this.selectedCurrency()];
  });

  protected readonly convertedAmount = computed(() => {
    return this.amount() ? this.amount()! * this.rate() : undefined;
  });
}
